module.exports = __webpack_public_path__ + "static/media/map.21ef8d03.png";